import { render } from "./TagDropdown.vue?vue&type=template&id=e2fc1104&scoped=true"
import script from "./TagDropdown.vue?vue&type=script&lang=js"
export * from "./TagDropdown.vue?vue&type=script&lang=js"

import "./TagDropdown.vue?vue&type=style&index=0&id=e2fc1104&lang=scss&scoped=true"
import "./TagDropdown.vue?vue&type=style&index=1&id=e2fc1104&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2fc1104"]])

export default __exports__